export default __webpack_public_path__ + "static/media/golf-impresa.fc795abe.png";